class ButtonPdp extends HTMLElement {
  constructor() {
    super();

    // Referencias a elementos internos
    this.quantityEl = this.querySelector('[data-quantity]');
    this.buttonSecondary = this.querySelector('[data-button-event="second"]');
    this.buttonPrimary = this.querySelector('[data-button-event="first"]');
    this.btnLess = this.querySelector('[data-event-less]');
    this.btnMore = this.querySelector('[data-event-more]');
    this.dataStock = this.quantityEl.dataset.stock;
    this.dataCartQuantity = this.quantityEl.dataset.cartQuantity;

    // Bind de métodos para evitar problemas en removeEventListener
    this.onCartRefresh = this.initButtons.bind(this);
  }

  connectedCallback() {
    this.initButtons();

    document.addEventListener('cart:refresh', this.onCartRefresh);

    if (this.btnLess) this.btnLess.addEventListener('click', this.handleLess.bind(this));
    if (this.btnMore) this.btnMore.addEventListener('click', this.handleMore.bind(this));
  }

  disconnectedCallback() {
    document.removeEventListener('cart:refresh', this.onCartRefresh);

    if (this.btnLess) this.btnLess.removeEventListener('click', this.handleLess);
    if (this.btnMore) this.btnMore.removeEventListener('click', this.handleMore);
  }

  /** Inicializa estado de los botones según carrito */
  async initButtons() {
    //const cart = await this.getCart();
    //if (cart) this.renderButtons(cart);
    this.renderButtons()
  }

  /** Muestra/oculta botones según si el producto está en el carrito */
  renderButtons(cart) {
    const productId = this.getAttribute('data-product-id');
    //const item = cart.items.find(i => String(i.id) === String(productId)) || null;
    const quantity = this.dataCartQuantity || 0;

    if (quantity > 0) {
      this.buttonPrimary?.classList.add('hidden');
      this.buttonSecondary?.classList.remove('hidden');
      //this.quantityEl.textContent = quantity;
    } else {
      this.buttonSecondary?.classList.add('hidden');
      this.buttonPrimary?.classList.remove('hidden');
    }
  }

  /** Disminuir cantidad */
  handleLess() {
    const newQuantity = Number(this.quantityEl.textContent) - 1;
    if (newQuantity < 0) return;
    this.quantityEl.textContent = newQuantity;

     if (this.updateTimeout) {
      clearTimeout(this.updateTimeout);
    }

    this.updateTimeout = setTimeout(() => {
      this.updateLineItems(newQuantity, this.btnLess.dataset.variantId);
    }, 500);
    /* const newQuantity = Number(this.quantityEl.textContent) - 1;
    this.updateCartQuantity(this.btnLess.dataset.variantId, newQuantity); */
  }

  /** Aumentar cantidad */
  handleMore() {
    const newQuantity = Number(this.quantityEl.textContent) + 1;

    if(newQuantity > this.dataStock){
      return;
    }

    this.quantityEl.textContent = newQuantity;

    if (this.updateTimeout) {
      clearTimeout(this.updateTimeout);
    }

    this.updateTimeout = setTimeout(() => {
      this.updateLineItems(newQuantity, this.btnMore.dataset.variantId);
    }, 300);

    
    /* const newQuantity = Number(this.quantityEl.textContent) + 1;
    this.updateCartQuantity(this.btnMore.dataset.variantId, newQuantity, true); */
  }

  async updateLineItems(quantity, variantId){
    try {
      this.lockButtons();

      const body = JSON.stringify({
        id: variantId,
        quantity: quantity
      });
      
      const response = await fetch('/cart/change.js?sections=cart-drawer,header', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body
      });
      
      if (!response.ok) {
        throw new Error(`Failed to remove item from cart: ${response.status}`);
      }
      
      const {sections, items} = await response.json();

      //almacenamo los items actualizado en el storage, esto lo usan los cardproduct apra no tener que consultar uno a uno
      if (items.length) {
        localStorage.setItem('current-cart', JSON.stringify(items));
      }
      
      //actualizamos la seccion renderizando el icono con la cantidad y precios del drawer
      this.renderSections(sections);

    } catch (error) {
      console.error(`Error from cart:`, error);
      throw error;
    } finally {        
      console.log('CART:REFRESH 5')
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }
  }

  renderSections(sections) {
    // 1) Actualizar el icono del carrito
    const bubbleHTML = sections['header'];
    if (bubbleHTML) {

      const tmpBubble = document.createElement('div');
      tmpBubble.innerHTML = bubbleHTML;

      const newBubble = tmpBubble.querySelector('#cart-icon-bubble .cart-count-bubble');
      const currentBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');

      if (newBubble && currentBubble) {
        currentBubble.replaceWith(newBubble);
      }else{
        currentBubble?.remove();
      }
    }

    // 2) Actualizar solo el contenedor de items del drawer
    const drawerHTML = sections['cart-drawer'];
    if (drawerHTML) {
      const tmpDrawer = document.createElement('div');
      tmpDrawer.innerHTML = drawerHTML;

      // en el HTML de la sección cart-drawer debe existir este id
      const newItems = tmpDrawer.querySelector('#CartDrawer-CartItems');
      const currentItems = document.querySelector('#CartDrawer-CartItems');

      if (newItems && currentItems) {
        currentItems.replaceWith(newItems);
      }
    }
  }

  lockButtons() {
    this.querySelectorAll('button').forEach(button => {
      button.setAttribute('disabled', 'disabled');
      button.classList.add('disabled');
    });
  }

  unlockButtons() {
    this.isUpdating = false;
    this.querySelectorAll('button').forEach(button => {
      button.removeAttribute('disabled');
      button.classList.remove('disabled');
    });
  }
}

customElements.define('button-pdp', ButtonPdp);